import { useSearchParams } from "react-router-dom";
import { Building2, Shirt, Store, CalendarDays, Briefcase, Package, Tag, Layers } from "lucide-react";
import { useSeo } from "@/lib/store";
import { EnquiryForm } from "@/components/EnquiryForm";

const WHO = [[Tag, "Clothing brands"], [Store, "Resellers & retailers"], [Building2, "Businesses"], [CalendarDays, "Event organizers"], [Briefcase, "Corporate buyers"], [Package, "Bulk apparel buyers"]];
const SERVICES = [["Bulk T-shirt manufacturing & printing", Shirt], ["Bulk hoodie printing", Layers], ["Custom logo printing", Tag], ["Private label apparel", Briefcase], ["Brand merchandise", Store], ["Wholesale clothing orders", Package]];

export default function Wholesale() {
  const [sp] = useSearchParams();
  useSeo("B2B Wholesale & Bulk Printing", "Bulk T-shirt and hoodie printing, private label apparel and wholesale clothing from DEN & THREADS, Kanpur.");
  return (
    <div data-testid="wholesale-page">
      <section className="max-w-[1500px] mx-auto px-4 sm:px-8 pt-14 pb-10">
        <p className="eyebrow">B2B · Wholesale · Private label</p>
        <h1 className="font-display text-6xl sm:text-8xl lg:text-[9rem] leading-[0.84] mt-4">YOUR BRAND.<br /><span className="text-neon">OUR PRODUCTION.</span></h1>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-px bg-white/10 mt-14">
          {WHO.map(([I, t]) => <div key={t} className="bg-[#080808] p-5"><I className="w-6 h-6 text-neon" /><p className="text-sm font-semibold mt-3">{t}</p></div>)}
        </div>
        <div className="grid md:grid-cols-3 gap-4 mt-14">
          {SERVICES.map(([t, I], i) => (
            <div key={t} className="bg-[#171717] p-7 group hover:bg-neon hover:text-black transition-colors">
              <div className="flex justify-between"><span className="font-mono text-xs">0{i + 1}</span><I className="w-5 h-5" /></div>
              <p className="font-display text-2xl mt-8 leading-none">{t}</p>
            </div>
          ))}
        </div>
      </section>
      <section className="max-w-[1500px] mx-auto px-4 sm:px-8 py-14">
        <h2 className="font-display text-4xl sm:text-5xl mb-10">BULK ENQUIRY</h2>
        <EnquiryForm variant="wholesale" design={sp.get("design") || ""} />
      </section>
    </div>
  );
}
